const ComponentBase = require('../../base/ComponentBase');
/**
 * @ignore
 * @constructor
 * @classdesc 缓冲区分析
 * @augments G.base.ComponentBase
 * @alias G.biz.BufferQuery
 * @param {Object} options - 必填，构造参数；
 * @param {G.Map} options.map - 必填，地图对象
 * @example
 * //使用示例代码
 * //todo
 */
let component = ComponentBase.extend({
    options: {},
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
    },
    /**
     * 销毁
     */
    destroy() {
        //
        ComponentBase.prototype.destroy.call(this);
    }
});
module.exports = component;